import React from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
import ShareBtn from '../ShareBtn'

// template 同時是 App.js 的萬用 route（/:pid、/ha/:pid），setIsDkabio 與 ?serial_num= 由那裡用到；
// 複製成新問卷時 routesConfig 不傳 setIsDkabio，hook 端會略過
// /:pid 另外傳的 isDkabio 刻意不接：hooks 不讀它，logo 由 App.js 的 isDkabio state 決定
function Layout({ setCompletionMessage, setIsDkabio }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn] = useState(true)

  const { pathname } = useLocation()
  // 萬用 route 的網址可能帶結尾斜線（/p123/），先去掉再取 pid
  const pid = 'P' + pathname.toLowerCase().replace(/\/+$/, '').split('/p')[1]
  const [searchParams] = useSearchParams()
  const serialNum = searchParams.get('serial_num')

  const actualInnerWidth = document.body.clientWidth - 20
  const shareUrl = `${window.location.origin}/${pid.toLowerCase()}`

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setCompletionMessage={setCompletionMessage}
        setIsDkabio={setIsDkabio}
        serial_num={serialNum}
      />
      <ShareBtn showShareBtn={showShareBtn} shareUrl={shareUrl} />
    </>
  )
}

export default Layout
